var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { type: "text", clearable: "", placeholder: "请输入昵称" },
            model: {
              value: _vm.listQuery.nickName,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "nickName", $$v)
              },
              expression: "listQuery.nickName"
            }
          }),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { type: "text", clearable: "", placeholder: "请输入手机号" },
            model: {
              value: _vm.listQuery.customerPhone,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "customerPhone", $$v)
              },
              expression: "listQuery.customerPhone"
            }
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择审核状态", clearable: "" },
              model: {
                value: _vm.listQuery.auditStatus,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "auditStatus", $$v)
                },
                expression: "listQuery.auditStatus"
              }
            },
            _vm._l(_vm.statusOptions, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择审核方式", clearable: "" },
              model: {
                value: _vm.listQuery.isSwitch,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "isSwitch", $$v)
                },
                expression: "listQuery.isSwitch"
              }
            },
            [
              _c("el-option", { attrs: { label: "人工审核", value: 0 } }),
              _c("el-option", { attrs: { label: "自动审核", value: 1 } })
            ],
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "姓名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.customerName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "昵称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.nickName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.mobilephone") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.customerPhone))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "身份" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.lvZhlxName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.bindingHouse"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.areaName) +
                          _vm._s(
                            scope.row.areaName !== scope.row.areaGroupName
                              ? scope.row.areaGroupName
                              : ""
                          ) +
                          _vm._s(scope.row.buildingName) +
                          _vm._s(scope.row.unintName) +
                          _vm._s(scope.row.houseCode)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.auditStatus") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == "0"
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("待审核")
                        ])
                      : scope.row.auditStatus == "1"
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("通过")
                        ])
                      : scope.row.auditStatus == "2"
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("未通过")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "审核方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isSwitch === 0
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("人工审核")
                        ])
                      : scope.row.isSwitch === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("自动审核")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "审核时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.checkedTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              width: "280px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini", plain: "" },
                            on: {
                              click: function($event) {
                                return _vm.handlePass(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.auditPass")))]
                        )
                      : _vm._e(),
                    scope.row.auditStatus === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini", plain: "" },
                            on: {
                              click: function($event) {
                                return _vm.handleUnPass(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.auditUnPass")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-delete"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(
                              scope.row.linkId,
                              scope.row.weixinOpenid
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.delete")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }